import React from 'react';
import { IListing } from '../models/listing.model';
import { Link } from 'react-router-dom';

export interface IListingLink {
  children: React.ReactNode;
  listing: IListing;
  openNewWindow?: boolean;
}

export const ListingLink: React.FC<IListingLink> = props => {

  return (
    <Link to={props.listing.uri} target={props.openNewWindow ? "_new" : ""}>
      {props.children}
    </Link>
  );
}

export default ListingLink;
